import dayjs from 'dayjs';
import clsx from 'clsx';
import { previewGroupGridClsx } from 'pages/client/Orders/Make/classnames';
import { OrderDeliveryType, publicDeliveryTypeTraderFullLabels } from 'utils/enums';
import FieldBlock from 'components/preview/FieldBlock';
import { ParsedOrder } from 'api/order.parsers';
import { orderHasExpiredDate } from 'utils/order';
import { DISPLAY_DATE_TEMPLATE } from 'utils/constants';

/**
 * Displays delivery details for a trade: latest delivery date, type, and location.
 */
export default function DeliveryPanel(props: ParsedOrder) {
  const orderIsExpired = orderHasExpiredDate(props.tradeStatus, props.latestDate);

  return (
    <section className={'flex flex-col gap-4'}>
      <div className={clsx(previewGroupGridClsx, orderIsExpired && 'bg-red-500/10')}>
        <FieldBlock label={'Latest delivery date'}>{dayjs(props.latestDate).format(DISPLAY_DATE_TEMPLATE)}</FieldBlock>

        {orderIsExpired && (
          <p
            className={
              'rounded-[40px] bg-[#FFD7D7] py-2.5 px-5 text-brand-red-main text-sm/tight font-semibold text-center self-center'
            }
          >
            This trade is expired
          </p>
        )}
      </div>

      <div className={previewGroupGridClsx}>
        <FieldBlock label={'Type'}>{publicDeliveryTypeTraderFullLabels[props.deliveryType]}</FieldBlock>

        {[OrderDeliveryType.NeedPickup, OrderDeliveryType.NeedDelivery].includes(props.deliveryType) && (
          <>
            <FieldBlock label={'Province'}>{props.provinces?.[0]?.label}</FieldBlock>
            <FieldBlock label={'Town'}>{props.town || 'Unknown'}</FieldBlock>
          </>
        )}

        {[OrderDeliveryType.CanDeliver, OrderDeliveryType.CanPickup].includes(props.deliveryType) && (
          <FieldBlock label={'Provinces'}>{props.provinces?.map((v) => v.label).join(', ')}</FieldBlock>
        )}
      </div>
    </section>
  );
}
